module.exports = __webpack_public_path__ + "img/blue_109.c2ea3998.png";